import { useCallback } from 'react';
import { useCollectPaymentMultiContext } from '../../../../collect-payment-multi.context';
import { useFinalizeStepTrackingCallbacks, useInitiateStepTracking } from '../../../../utils/step-tracking-store';
import { PAYMENT_MULTI_STEPS } from '../../../../utils/steps';
import { CollectTerminalStepNavigationProps } from '../collect-terminal.types';

export const CollectTerminalGenericNavigation = ({ body: Body }: CollectTerminalStepNavigationProps) => {
  const {
    onPaymentSuccess: onPaymentSuccessContext,
    multiStep: { goPrevStep, onCancel },
    activeGateway,
    flow,
  } = useCollectPaymentMultiContext();

  const { completeStepTracking, cancelStepTracking } = useFinalizeStepTrackingCallbacks({
    step: 'collect-reader-payment',
    variant: 'default',
  });

  const onGoBack = useCallback(() => {
    goPrevStep({ orStep: PAYMENT_MULTI_STEPS.paymentMethods });
    cancelStepTracking();
  }, [goPrevStep, cancelStepTracking]);

  const onPaymentSuccess = useCallback(() => {
    onPaymentSuccessContext?.();
    completeStepTracking();
  }, [onPaymentSuccessContext, completeStepTracking]);

  const onInvoiceSent = useCallback(() => {
    onCancel?.();
    completeStepTracking();
  }, [onCancel, completeStepTracking]);

  const onCloseWithoutReceipt = useCallback(() => {
    onCancel?.();
    cancelStepTracking();
  }, [onCancel, cancelStepTracking]);

  useInitiateStepTracking({
    step: 'collect-reader-payment',
    flow,
    activeGateway,
    screenWidth: window.innerWidth,
    variant: 'default',
  });
  return (
    <Body
      onPaymentSuccess={onPaymentSuccess}
      onGoBack={onGoBack}
      onInvoiceSent={onInvoiceSent}
      onCloseWithoutReceipt={onCloseWithoutReceipt}
    />
  );
};
